import { styled } from '@mui/material/styles';
import { Divider, ListSubheader, ListItem as MuiListItem } from '@mui/material';
import { MenuItem } from './MenuItem';
import { SubMenu } from './SubMenu';
import { WorkspaceSubMenu } from './WorkspaceSubMenu';

const ListItem = styled(MuiListItem)(({ theme }) => ({
  padding: '0 14px',
  marginBottom: '6px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: theme.palette.common.white,
}));

export const SidebarItem = ({ item, wide, toggleWide, selected }) => {
  const commonProps = { item, wide, selected, toggleWide };

  const renderMenuItem = () => {
    switch (item.type) {
      case 'item':
        return (
          <MenuItem
            {...commonProps}
            sx={{ minHeight: 32 }}
          />
        );
      case 'divider':
        return <Divider sx={{ my: 1 }} />;
      case 'subheader':
        return wide ? (
          <ListSubheader
            component="div"
            inset
          >
            {item.title}
          </ListSubheader>
        ) : null;
      case 'submenu':
        return (
          <SubMenu
            {...commonProps}
            key={item.title}
          />
        );
      default:
        return null;
    }
  };

  if (item.title === 'Workspace') {
    return (
      <ListItem disablePadding>
        <WorkspaceSubMenu
          {...commonProps}
          key={item.title}
        />
      </ListItem>
    );
  }

  return <ListItem disablePadding>{renderMenuItem()}</ListItem>;
};
